import styled from 'styled-components';


const FormLayout = styled.div`
	position: relative;
	width: 100%;
	max-width: 480px;
`;

export {
	FormLayout,
};
